import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faYoutube,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';

export const shopLinks = [
  { name: 'All Products', href: '/products' },
  { name: 'Categories', href: '/categories' },
  { name: 'New Arrivals', href: '/new' },
  { name: 'Best Sellers', href: '/best-sellers' },
  { name: 'Deals & Offers', href: '/deals' },
];

export const companyLinks = [
  { name: 'About Us', href: '/about' },
  { name: 'Careers', href: '/careers' },
  { name: 'Blog', href: '/blog' },
  { name: 'Press', href: '/press' },
  { name: 'Partners', href: '/partners' },
];

export const supportLinks = [
  { name: 'Help Center', href: '/help' },
  { name: 'Contact Us', href: '/contact' },
  { name: 'Shipping Info', href: '/shipping' },
  { name: 'Returns & Refunds', href: '/returns' },
  { name: 'FAQs', href: '/faq' },
];

export const socials = [
  { icon: faFacebookF, href: '#', label: 'Facebook' },
  { icon: faTwitter, href: '#', label: 'Twitter' },
  { icon: faInstagram, href: '#', label: 'Instagram' },
  { icon: faYoutube, href: '#', label: 'YouTube' },
  { icon: faLinkedinIn, href: '#', label: 'LinkedIn' },
];